"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("./styles");
function Placeholder(_a) {
    var embed = _a.embed;
    return (jsx_runtime_1.jsx(styles_1.PlaceholderContainer, __assign({ embed: embed }, { children: jsx_runtime_1.jsx(styles_1.PlaceholderContent, { children: jsx_runtime_1.jsxs("svg", __assign({ viewBox: "0 0 736 414", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx_runtime_1.jsx("path", { d: "M0 6C0 2.68629 2.68629 0 6 0H730C733.314 0 736 2.68629 736 6V408C736 411.314 733.314 414 730 414H6.00001C2.6863 414 0 411.314 0 408V6Z", fill: "black", fillOpacity: "0.04" }, void 0), jsx_runtime_1.jsx("path", { opacity: "0.16", d: "M381.286 205.304L355.06 188.912C353.728 188.08 352 189.038 352 190.608V223.392C352 224.962 353.728 225.92 355.06 225.088L381.286 208.696C382.54 207.913 382.54 206.087 381.286 205.304Z", fill: "black" }, void 0)] }), void 0) }, void 0) }), void 0));
}
exports.default = Placeholder;
